import { Link } from 'react-router-dom';
import { useStoreConfig } from '../context/StoreConfigContext.jsx';
import '../styles/components/FooterStyle.css';

export function Footer() {
  const { site } = useStoreConfig();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-column">
          <div className="footer-brand">
            <img
              className="footer-brand-img"
              src="/include/images/logo.png"
              alt={site.name}
              width="56"
              height="56"
              loading="lazy"
              decoding="async"
            />
            <strong>{site.name}</strong>
          </div>
          <p>
            The official store for {site.name} — a Minecraft skymining server. Every purchase keeps
            the islands afloat.
          </p>
        </div>

        <div className="footer-column">
          <h3>
            <i className="fa-solid fa-link" /> Links
          </h3>
          <ul className="footer-links">
            <li>
              <Link to="/home/">
                <i className="fa-solid fa-house" /> Home
              </Link>
            </li>
            <li>
              <a href={site.website_url} target="_blank" rel="noopener noreferrer">
                <i className="fa-solid fa-globe" /> Main Website
              </a>
            </li>
            <li>
              <a href={site.discord_url} target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-discord" /> Discord
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>
            <i className="fa-solid fa-shield-halved" /> Legal
          </h3>
          <ul className="footer-links">
            <li>
              <Link to="/terms/">Refund Policy</Link>
            </li>
            <li>
              <Link to="/legal/">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms/">Terms of Service</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {year} <strong>{site.name}</strong> — All rights reserved. Not affiliated with
          Mojang AB.
        </p>
      </div>
    </footer>
  );
}
